import fetchData from "./util/FetchSignalInfo";

let Menu = [];

const gen = fetchData();
loadMenu();

function loadMenu() {
    gen.next().then(({ value }) => {
        if (value.loading) {
            setTimeout(loadMenu, 100);
        } else {
            const { data } = value;
            if (data) {
                // we divide the nav into two sections, one for signals and the other for risk factors
                const signalPath = "signal";
                const riskFactorPath = "risk-factor";

                Menu.push({
                    name: 'Signals',
                    submenu: data
                        .filter((signal) => signal.menuPath === signalPath)
                        .map(signal => {
                            return {
                                name: signal.signalName,
                                path: `/${signalPath}/${signal.internalId}`,
                            }
                        })
                });
                Menu.push({
                    name: 'Risk Factors',
                    submenu: data
                        .filter((signal) => signal.menuPath === riskFactorPath)
                        .map(signal => {
                            return {
                                name: signal.signalName,
                                path: `/${riskFactorPath}/${signal.internalId}`,
                            }
                        })
                });
            }
        }
    });
}

export default Menu;